import { Button, TextField } from '@mui/material';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

function Login() {
  const [data, setData] = useState({
    mobile: "",
    password: ""
  });

  const navigate = useNavigate();

  function getData(e) {
    const { name, value } = e.target;
    setData(prev => ({ ...prev, [name]: value }));
  }

  async function postData(e) {
    e.preventDefault();

    try {
      let response = await fetch(
        "https://msdskserver.onrender.com/api/user/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      response = await response.json();

      if (response.result === "Done") {
        sessionStorage.setItem("login", "true");
        sessionStorage.setItem("name", response.data.name);
        sessionStorage.setItem("mobile", response.data.mobile);
        sessionStorage.setItem("userid", response.data._id);
        sessionStorage.setItem("role", response.data.role);
        sessionStorage.setItem("token", response.token);

        // 🔥 Role based redirect
        if (response.data.role === "SuperAdmin") {
          navigate("/superadmin");
        } else {
          navigate("/dashboard");
        }
      } else {
        alert(response.message || "Invalid username or password");
      }
    } catch (error) {
      console.error("Login error:", error);
      alert("Server error, please try again later");
    }
  }

  return (
    <div className="loginFrom">
      <h4>Login Form</h4>

      <form onSubmit={postData}>
        <div className="mb-3">
          <TextField
            variant="standard"
            fullWidth
            label="Username"
            name="mobile"
            placeholder="Enter Mobile Number"
            onChange={getData}
            required
          />
        </div>

        <div className="mb-3">
          <TextField
            variant="standard"
            fullWidth
            label="Password"
            name="password"
            type="password"
            placeholder="Enter Password"
            onChange={getData}
            required
          />
        </div>

        <div className="mt-4 mb-3">
          <Button
            type="submit"
            className="text-light w-100 bg-success"
          >
            Login
          </Button>
        </div>
      </form>

      <div className="text-center">
        <Link to="/forgetpassword">Forget Password?</Link>
      </div>
    </div>
  );
}

export default Login;
